import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { useLanguage } from '../contexts/LanguageContext';
const termsContent = {
  en: {
    title: 'Terms of',
    titleHighlight: 'Service',
    lastUpdated: 'Last updated: February 3, 2026',
    sections: [{
      title: '1. Agreement to Terms',
      content: `By accessing or using it Marker's services, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not use our services.`
    }, {
      title: '2. Services Description',
      content: `it Marker provides professional web design and development services, including:
- Free website demo creation
- Custom website design and development
- Website hosting setup assistance
- 30 days of post-launch support`
    }, {
      title: '3. Pricing and Payment',
      content: `**Free Demo:** We provide a free website demo with no obligation. You only pay if you approve the design and want to launch.
**Professional Package (1200 zł):** One-time payment for complete website. Payment required after demo approval before final launch.
**Hosting (40 zł/month):** Optional hosting and maintenance service.
All prices are in Polish Zloty (PLN). Payments are non-refundable once work has commenced.`
    }, {
      title: '4. Project Timeline',
      content: `Standard projects are completed within 24 hours from demo approval. Timeline may vary based on:
- Project complexity
- Client feedback response time
- Content availability`
    }, {
      title: '5. Revisions and Changes',
      content: `Our package includes 3 rounds of revisions. Additional revisions may incur extra charges. Major scope changes after approval may require additional fees.`
    }, {
      title: '6. Intellectual Property',
      content: `Upon full payment, you own all rights to the final website design and code. Before payment, all work remains property of it Marker.`
    }, {
      title: '7. Client Responsibilities',
      content: `Clients are responsible for:
- Providing accurate content and materials
- Timely feedback and approvals
- Domain registration and hosting (if not using our services)
- Compliance with applicable laws`
    }, {
      title: '8. Limitation of Liability',
      content: `it Marker is not liable for indirect, incidental, or consequential damages arising from use of our services. Our total liability is limited to the amount paid for services.`
    }, {
      title: '9. Termination',
      content: `Either party may terminate the agreement with written notice. Payments for completed work are non-refundable.`
    }, {
      title: '10. Contact',
      content: `For questions about these Terms, contact us at:
Email: legal@jetly.agency
Telegram: @jetlyagency`
    }]
  },
  pl: {
    title: 'Warunki',
    titleHighlight: 'Świadczenia Usług',
    lastUpdated: 'Ostatnia aktualizacja: 3 lutego 2026',
    sections: [{
      title: '1. Akceptacja Warunków',
      content: `Uzyskując dostęp do usług it Marker lub korzystając z nich, zgadzasz się na przestrzeganie niniejszych Warunków Świadczenia Usług. Jeśli nie zgadzasz się z jakąkolwiek częścią tych warunków, nie możesz korzystać z naszych usług.`
    }, {
      title: '2. Opis Usług',
      content: `it Marker świadczy profesjonalne usługi projektowania i tworzenia stron internetowych, w tym:
- Darmowe tworzenie wersji demonstracyjnej strony
- Niestandardowe projektowanie i tworzenie stron
- Pomoc w konfiguracji hostingu
- 30 dni wsparcia po uruchomieniu`
    }, {
      title: '3. Ceny i Płatności',
      content: `**Darmowe Demo:** Zapewniamy darmowe demo strony bez zobowiązań. Płacisz tylko wtedy, gdy zatwierdzisz projekt i chcesz go uruchomić.
**Pakiet Profesjonalny (1200 zł):** Jednorazowa płatność za kompletną stronę. Płatność wymagana po zatwierdzeniu dema, przed ostatecznym uruchomieniem.
**Hosting (40 zł/miesiąc):** Opcjonalna usługa hostingu i utrzymania.
Wszystkie ceny podane są w polskich złotych (PLN). Płatności nie podlegają zwrotowi po rozpoczęciu prac.`
    }, {
      title: '4. Harmonogram Projektu',
      content: `Standardowe projekty są realizowane w ciągu 24 godzin od zatwierdzenia dema. Harmonogram może się różnić w zależności od:
- Złożoności projektu
- Czasu reakcji klienta na opinie
- Dostępności treści`
    }, {
      title: '5. Poprawki i Zmiany',
      content: `Nasz pakiet obejmuje 3 rundy poprawek. Dodatkowe poprawki mogą wiązać się z dodatkowymi opłatami. Główne zmiany zakresu po zatwierdzeniu mogą wymagać dodatkowych opłat.`
    }, {
      title: '6. Własność Intelektualna',
      content: `Po pełnej zapłacie posiadasz wszystkie prawa do ostatecznego projektu strony i kodu. Przed zapłatą wszystkie prace pozostają własnością it Marker.`
    }, {
      title: '7. Obowiązki Klienta',
      content: `Klienci są odpowiedzialni za:
- Dostarczenie dokładnych treści i materiałów
- Terminowe opinie i zatwierdzenia
- Rejestrację domeny i hosting (jeśli nie korzystają z naszych usług)
- Zgodność z obowiązującym prawem`
    }, {
      title: '8. Ograniczenie Odpowiedzialności',
      content: `it Marker nie ponosi odpowiedzialności za pośrednie, przypadkowe lub wtórne szkody wynikające z korzystania z naszych usług. Nasza całkowita odpowiedzialność jest ograniczona do kwoty zapłaconej za usługi.`
    }, {
      title: '9. Rozwiązanie Umowy',
      content: `Każda ze stron może rozwiązać umowę za pisemnym wypowiedzeniem. Płatności za wykonane prace nie podlegają zwrotowi.`
    }, {
      title: '10. Kontakt',
      content: `W przypadku pytań dotyczących niniejszych Warunków, skontaktuj się z nami:
Email: legal@jetly.agency
Telegram: @jetlyagency`
    }]
  },
  ru: {
    title: 'Условия',
    titleHighlight: 'Использования',
    lastUpdated: 'Последнее обновление: 3 февраля 2026',
    sections: [{
      title: '1. Согласие с Условиями',
      content: `Получая доступ к услугам it Marker или используя их, вы соглашаетесь соблюдать настоящие Условия Использования. Если вы не согласны с какой-либо частью этих условий, вы не можете использовать наши услуги.`
    }, {
      title: '2. Описание Услуг',
      content: `it Marker предоставляет профессиональные услуги по дизайну и разработке веб-сайтов, включая:
- Бесплатное создание демо-версии сайта
- Индивидуальный дизайн и разработка сайта
- Помощь в настройке хостинга
- 30 дней поддержки после запуска`
    }, {
      title: '3. Цены и Оплата',
      content: `**Бесплатное Демо:** Мы предоставляем бесплатное демо сайта без обязательств. Вы платите только в том случае, если одобряете дизайн и хотите запустить сайт.
**Профессиональный Пакет (1200 zł):** Единоразовая оплата за готовый сайт. Оплата требуется после утверждения демо до финального запуска.
**Хостинг (40 zł/месяц):** Дополнительная услуга хостинга и обслуживания.
Все цены указаны в польских злотых (PLN). Оплата не подлежит возврату после начала работ.`
    }, {
      title: '4. Сроки Проекта',
      content: `Стандартные проекты выполняются в течение 24 часов после утверждения демо. Сроки могут варьироваться в зависимости от:
- Сложности проекта
- Времени ответа клиента
- Наличия контента`
    }, {
      title: '5. Правки и Изменения',
      content: `Наш пакет включает 3 раунда правок. Дополнительные правки могут потребовать дополнительной оплаты. Значительные изменения объема после утверждения могут потребовать дополнительной оплаты.`
    }, {
      title: '6. Интеллектуальная Собственность',
      content: `После полной оплаты вы получаете все права на финальный дизайн сайта и код. До оплаты все работы остаются собственностью it Marker.`
    }, {
      title: '7. Обязанности Клиента',
      content: `Клиенты несут ответственность за:
- Предоставление точного контента и материалов
- Своевременную обратную связь и утверждения
- Регистрацию домена и хостинг (если не используются наши услуги)
- Соблюдение применимого законодательства`
    }, {
      title: '8. Ограничение Ответственности',
      content: `it Marker не несет ответственности за косвенные, случайные или последующие убытки, возникшие в результате использования наших услуг. Наша общая ответственность ограничена суммой, уплаченной за услуги.`
    }, {
      title: '9. Расторжение',
      content: `Любая из сторон может расторгнуть соглашение с письменным уведомлением. Оплата за выполненные работы не подлежит возврату.`
    }, {
      title: '10. Контакты',
      content: `По вопросам, касающимся настоящих Условий, свяжитесь с нами:
Email: legal@jetly.agency
Telegram: @jetlyagency`
    }]
  },
  ua: {
    title: 'Умови',
    titleHighlight: 'Використання',
    lastUpdated: 'Останнє оновлення: 3 лютого 2026',
    sections: [{
      title: '1. Згода з Умовами',
      content: `Отримуючи доступ до послуг it Marker або використовуючи їх, ви погоджуєтеся дотримуватися цих Умов Використання. Якщо ви не згодні з будь-якою частиною цих умов, ви не можете використовувати наші послуги.`
    }, {
      title: '2. Опис Послуг',
      content: `it Marker надає професійні послуги з дизайну та розробки веб-сайтів, включаючи:
- Безкоштовне створення демо-версії сайту
- Індивідуальний дизайн та розробка сайту
- Допомога в налаштуванні хостингу
- 30 днів підтримки після запуску`
    }, {
      title: '3. Ціни та Оплата',
      content: `**Безкоштовне Демо:** Ми надаємо безкоштовне демо сайту без зобов'язань. Ви платите тільки в тому випадку, якщо схвалюєте дизайн і хочете запустити сайт.
**Професійний Пакет (1200 zł):** Одноразова оплата за готовий сайт. Оплата потрібна після затвердження демо до фінального запуску.
**Хостинг (40 zł/місяць):** Додаткова послуга хостингу та обслуговування.
Всі ціни вказані в польських злотих (PLN). Оплата не підлягає поверненню після початку робіт.`
    }, {
      title: '4. Терміни Проєкту',
      content: `Стандартні проєкти виконуються протягом 24 годин після затвердження демо. Терміни можуть змінюватися залежно від:
- Складності проєкту
- Часу відповіді клієнта
- Наявності контенту`
    }, {
      title: '5. Правки та Зміни',
      content: `Наш пакет включає 3 раунди правок. Додаткові правки можуть вимагати додаткової оплати. Значні зміни обсягу після затвердження можуть вимагати додаткової оплати.`
    }, {
      title: '6. Інтелектуальна Власність',
      content: `Після повної оплати ви отримуєте всі права на фінальний дизайн сайту та код. До оплати всі роботи залишаються власністю it Marker.`
    }, {
      title: `7. Обов'язки Клієнта`,
      content: `Клієнти несуть відповідальність за:
- Надання точного контенту та матеріалів
- Своєчасний зворотний зв'язок та затвердження
- Реєстрацію домену та хостинг (якщо не використовуються наші послуги)
- Дотримання чинного законодавства`
    }, {
      title: '8. Обмеження Відповідальності',
      content: `it Marker не несе відповідальності за непрямі, випадкові або подальші збитки, що виникли в результаті використання наших послуг. Наша загальна відповідальність обмежена сумою, сплаченою за послуги.`
    }, {
      title: '9. Розірвання',
      content: `Будь-яка зі сторін може розірвати угоду з письмовим повідомленням. Оплата за виконані роботи не підлягає поверненню.`
    }, {
      title: '10. Контакти',
      content: `З питань щодо цих Умов, зв'яжіться з нами:
Email: legal@jetly.agency
Telegram: @jetlyagency`
    }]
  }
};
export function TermsPage() {
  const {
    language
  } = useLanguage();
  const content = termsContent[language as keyof typeof termsContent] || termsContent.en;
  const formatContent = (text: string) => {
    return text.split('\n').map((line, i) => {
      const formattedLine = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
      if (line.startsWith('- ')) {
        return <li key={i} className="ml-4" dangerouslySetInnerHTML={{
          __html: formattedLine.substring(2)
        }} data-id="element-847" />;
      }
      if (line.trim() === '') {
        return <br key={i} data-id="element-848" />;
      }
      return <p key={i} className="mb-2" dangerouslySetInnerHTML={{
        __html: formattedLine
      }} data-id="element-849" />;
    });
  };
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-850">
      <Navigation data-id="element-851" />

      <div className="pt-32 pb-20 px-4" data-id="element-852">
        <div className="max-w-4xl mx-auto" data-id="element-853">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-854">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{
            color: 'var(--text-primary)'
          }} data-id="element-855">
              {content.title}{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-856">
                {content.titleHighlight}
              </span>
            </h1>
            <p className="text-sm mb-8" style={{
            color: 'var(--text-muted)'
          }} data-id="element-857">
              {content.lastUpdated}
            </p>

            <div className="space-y-8" data-id="element-858">
              {content.sections.map((section, index) => <Section key={index} title={section.title} data-id="element-859">
                  {formatContent(section.content)}
                </Section>)}
            </div>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-860" />
      <CookieBanner data-id="element-861" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border p-6 sm:p-8" style={{
    borderColor: 'var(--border)',
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-862">
      <h2 className="text-xl sm:text-2xl font-bold mb-4" style={{
      color: 'var(--text-primary)'
    }} data-id="element-863">
        {title}
      </h2>
      <div className="space-y-3 text-sm sm:text-base &[>ul]:list-disc &[>ul]:ml-6 &[>ul]:space-y-2" style={{
      color: 'var(--text-secondary)'
    }} data-id="element-864">
        {children}
      </div>
    </div>;
}